var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32393",
    "data-name": "Group 32393",
    transform: "translate(-45 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 24,
    height: 24,
    transform: "translate(45 56)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33300",
    "data-name": "Group 33300",
    transform: "translate(-8005.751 355)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17136",
    "data-name": "Path 17136",
    d: "M674.7,353a3.277,3.277,0,0,0,3.3-3.257v-2.592a2.151,2.151,0,1,1,0-4.3v-2.593A3.277,3.277,0,0,0,674.7,337H661.3a3.277,3.277,0,0,0-3.3,3.257v2.678A2.09,2.09,0,0,1,660.177,345a2.159,2.159,0,0,1-2.177,2.15v2.592A3.277,3.277,0,0,0,661.3,353Z",
    transform: "translate(7394.751 -632)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17139",
    "data-name": "Path 17139",
    d: "M388,285.327v6",
    transform: "translate(7674.751 -575.327)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17140",
    "data-name": "Path 17140",
    d: "M390.333,288.991h-6",
    transform: "translate(7675.418 -575.991)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketMenu);
export default __webpack_public_path__ + "static/media/ticket-menu.505b06fb105ad9610468a0c622010d2d.svg";
export { ForwardRef as ReactComponent };